import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import Favorite from './Favorite'
import Tag from '../../../Parts/Tag'
import './styles.scss';

const Listing = (props) => {
    let address = (props.loc_address && props.loc_address['county']) ? props.loc_address['county'] + (props.full_state ? `, ${props.full_state}` : '') : props.full_state ? props.full_state : '';

    useEffect(() => {
        const TRACKING_ID = "G-JRDY0PZRZR";
        ReactGA.initialize(TRACKING_ID);

        let url = new URL(props.permalink);
        ReactGA.event({
            category: 'Search',
            action: 'Impression',
            label: props.title,
            nonInteraction: true
        });
    }, [])

    let schema;

    if(props.loc_address){
      let streetAddress = props.loc_address['street'] ? `"streetAddress" : "${props.loc_address['street']},"` : '';
      let addressLocality = props.loc_address['city'] ? `"addressLocality" : "${props.loc_address['city']},"` : '';
      let addressRegion = props.loc_address['state'] ? `"addressRegion" : "${props.loc_address['state']},"` : '';
      let postalCode = props.loc_address['zipcode'] ? `"postalCode" : "${props.loc_address['zipcode']},"` : '';
      let  availability = props.listing_status ===  'available' ? 'http://schema.org/InStock' : 'http://schema.org/SoldOut'

      schema = {
          "@context":"http://schema.org",
          "@type":[
              "Product",
              "RealEstateListing",
              "Place"
          ],
          "brand":"Hayden Outdoors",
          "name":`"${props.title}"`,
          "url":`"${props.permalink}"`,
          "image":`"${props.featured_image}"`,
          "hasMap":`"https://www.google.com/maps/place/${props.lat},${props.lng}"`,
          "description":`"${props.description_raw}"`,
          "address": {
              "@type":"PostalAddress",
              streetAddress,
              addressLocality,
              addressRegion,
              postalCode
          },
          "offers":{
              "@type":"Offer",
              "priceCurrency":"USD",
              "price": props.current_price,
              "priceValidUntil": `"${props.expiration_date}"`,
              "url": `"${props.permalink}"`,
              availability
          },
          "geo":{
              "@type":"GeoCoordinates",
              "latitude":props.lat,
              "longitude":props.lng
          }
      }

      schema = JSON.stringify(schema)
    }

    const title = `<a href=${props.permalink}>${props.title}</a>`;
    const titleNoLink = `${props.title}`;


  return (
        <div className="col-12 col-md-6 col-lg-4 p-0 px-md-2-point-5 pb-md-4">
            <div className={`listing-container ${props.listing_status}`}>
                <div className="bg-image" style={{ backgroundImage: `url(${props.featured_image})` }}>
                {!props.buyer_represented &&
                  <a href={props.permalink} className="stretched-link"></a>
                }
                  <Tag new={props.new_listing} reduced={props.price_reduction} buyerRepresented={props.buyer_represented || props.buyer_agent} />
                  <Favorite propertyId={props.id} favorites={props.favorites} refreshUser={props.refreshUser} togglePropertyDetailsModal={props.togglePropertyDetailsModal} />
                </div>
                <div className="content">
                    <div className="d-flex align-items-center">
                      <div className="" dangerouslySetInnerHTML={{ __html: props.listing_status_formatted }} />
                      <div className="ml-auto btn-quickview d-none d-md-block" onClick={props.listing_status !== 'buyer_represented' ? () => props.togglePropertyDetailsModal(props.id) : ''}>Quickview</div>
                    </div>

                    {!props.buyer_represented &&
                      <h2 className="title" dangerouslySetInnerHTML={{ __html: title}} />
                    }
                    {props.buyer_represented &&
                      <h2 className="title" dangerouslySetInnerHTML={{ __html: titleNoLink}} />
                    }
                    <div className="county">
                      <span>{address}</span>
                      
                      {(address && props.total_combined_acres_formatted) && <span className="divider"></span>}
                      <span>{props.total_combined_acres_formatted && props.total_combined_acres_formatted}<>&nbsp;Acres</></span>
                    </div>
                    {
                        (props.excerpt) &&
                        <p className="excerpt">
                            <span dangerouslySetInnerHTML={{ __html: props.excerpt }} />
                            {
                                props.listing_status !== 'buyer_represented' &&
                                <a href={props.permalink} className="">View Full Listing</a>
                            }
                        </p>
                    }
                  <div className="listing-container-footer">
                    <div>
                      {props.current_price_formatted && '$' + props.current_price_formatted && <span className="divider d-inline-block"></span>}
                      {props.is_auction &&
                        <span className="price d-inline-block">Auction</span>}
                      {!props.is_auction &&
                        <span className="price d-inline-block">{props.current_price_formatted && '$' + props.current_price_formatted}</span>}
                    </div>
                    <div className="listing-controls ml-auto">
                      {props.property_video && <div className="btn-listing-control btn-listing-control-video" onClick={ () => {props.toggleVideoModal(props.id, props.video_raw, props.property_video);}}><span className="sr-only">View video</span></div>}
                      <div className="btn-listing-control btn-listing-control-map" onClick={ () => {props.changeToMapView(props.id);}}><span className="sr-only">View on map</span></div>
                    </div>
                  </div>
                </div>
            </div>

            {schema &&
              <script type='application/ld+json' dangerouslySetInnerHTML={ { __html: schema} } />}

        </div>
    )
}

export default Listing;
